var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash-table-cell-wrapper',{attrs:{"placeholder":_vm.contextualPlaceholder,"highlighted":_vm.field.isHighlighted() && !_vm.isInherited,"inherited":_vm.isInherited,"indicator":_vm.indicator}},[(_vm.field.value())?_c('span',{class:{ bold: _vm.bold },attrs:{"data-test-cell-value":""},domProps:{"innerHTML":_vm._s(_vm.processed)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }